










import { computed, defineComponent } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import { AvatarHelper } from '@getaccept/lib-shared/src/helpers/avatars.helper';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  name: 'RecipientItem',
  props: {
    recipient: {
      default: () => ({} as Recipient),
      type: Object as PropType<Recipient>,
    },
  },
  setup(props) {
    const titleAndCompanyName = computed(() => {
      if (!props.recipient.companyName) {
        return '';
      }

      if (props.recipient.companyName && props.recipient.title) {
        return `, ${props.recipient.title} ${t('dsr_at_company')} ${props.recipient.companyName}`;
      } else {
        return `, ${props.recipient.companyName}`;
      }
    });

    return {
      displayName: AvatarHelper.getDisplayName,
      titleAndCompanyName,
    };
  },
});
